<template>
    <label class="flex-form__field" :class="getInvalidClass('clickNumber')">
        <div class="flex-form__label">
            Click Count

            <tooltip>
                "Odd-Numbered Clicks" means firing the event on the first click, third click, etc etc - and vice versa for the "Even-Numbered" clicks.
            </tooltip>
        </div>

        <dropdown v-model="dataNew.clickNumber" class="flex-form__dropdown" :options="clickOptions" />
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'trigger-click',
    mixins: [eventDataMixin],

    data() {
        return {
            clickOptions: [
                { text: 'All Clicks', value: 0 },
                { text: 'Odd-Numbered Clicks', value: 1 },
                { text: 'Even-Numbered Clicks', value: 2 },
            ],

            schema: {
                clickNumber: {
                    type: Number,
                    default: 0,
                },
            },
        };
    },
};
</script>
